<template>
  <div class="d-flex align-content-between">
    <a
      class="btn btn-primary btn-tag btn-sm btn-ellipsis-calendar"
      v-if="text"
      :title="text"
      :style="styleBtnTag"
    >
      {{ text | formatDate }}
      <span class="bi bi-x-lg" style="cursor: pointer" @click="removeTags"></span>
    </a>
    <div class="mx-1" v-if="text"></div>
    <div class="position-relative">
      <button type="button" :style="styleBtn" class="btn btn-outline-dark btn-filter btn-calendar btn-filter-calendar" style="cursor: pointer">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_7482_69160)">
            <path
              d="M18 5H6C4.89543 5 4 5.89543 4 7V19C4 20.1046 4.89543 21 6 21H18C19.1046 21 20 20.1046 20 19V7C20 5.89543 19.1046 5 18 5Z"
              stroke="#373C3F" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round"></path>
            <path d="M16 3V7" stroke="#373C3F" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round"></path>
            <path d="M8 3V7" stroke="#373C3F" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round"></path>
            <path d="M4 11H20" stroke="#373C3F" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round"></path>
            <path d="M9.5 15H8" stroke="#373C3F" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round"></path>
          </g>
          <defs >
            <clipPath id="clip0_7482_69160">
              <rect width="24" height="24" fill="white"></rect>
            </clipPath>
          </defs>
        </svg>
      </button>
      <input
        type="date"
        class="date-input"
        :id="id"
        ref="dateInput"
        @change="onDateSelect"
        :value="selectedDate"
      >
    </div>
  </div>
</template>


<script>
export default {
  name: 'EpDatePicker',
  props: ['id', 'styleBtn', 'styleBtnTag'],
  data() {
    return {
      text: null,
      selectedDate: '',
      isDatePickerVisible: false
    };
  },
  mounted() {
    const elm = document.querySelectorAll('button.btn-calendar');
    elm[0].addEventListener('click', (e) => {
      e.preventDefault();
      this.isDatePickerVisible = true;
      this.$refs.dateInput.showPicker();
    })
  },
  methods: {
    onDateSelect(event) {
      this.selectedDate = event.target.value;
      this.text = event.target.value;
      this.isDatePickerVisible = false;
    },
    removeTags() {
      this.text = null;
      this.selectedDate = '';
    }
  },
  filters: {
    formatDate(value) {
      if (!value) {
        return '';
      }
      value = value + 'T00:00:01';
      return new Intl.DateTimeFormat('pt-BR', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
      }).format(new Date(value));
    }
  },
  watch: {
    selectedDate(value) {
      this.$emit('update:date', value);
    }
  }
};
</script>


<style lang="scss" scoped>
.btn-ellipsis-calendar {
  border-radius: 8px;
  margin-right: 8px;
  overflow: hidden;
  max-width: 150px!important;
  height: 45px!important;
  padding: 10px!important;
  padding-top: 11px!important;
  white-space: nowrap!important;
  text-overflow: ellipsis
}
.btn-filter-calendar {
  &:hover {
    background: #fff;
  }

  color: #373c3f;
  border-radius: 8px;
  border: 1px solid #dcdde4;
  text-align: center;
  font-family: $font-secondary;
  font-size: 16px;
  font-weight: 600;
  position: relative;
  padding: 0;
  width: 45px;
  height: 45px;
}

.badge {
  padding: 4px 8px;
  height: 27px;
  border-radius: 56px;
  line-height: 1.5;
  font-family: $font-secondary;
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  text-align: center;
}

.badge-primary {
  background: $primary-color;
  color: #fff;
}

.badge-gray {
  background: #e9edef;
  color: #4b5053;
}

.date-input {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  opacity: 0;
  width: 100%;
  height: 100%;
}

</style>
